
define( 'FORCES_AND_MOTION_BASICS/../nls/fa/forces-and-motion-basics-strings',{
          "none": "صفر",
          "force": "نيرو",
          "values": "مقدارها",
          "frictionTitle": "اصطكاك",
          "redWins": "قرمز برنده شد",
          "frictionForce": "نيروي اصطكاك",
          "pause": "مكث",
          "friction": "اصطكاك",
          "forces-and-motion-basics.name": "آشنايي با نيروها و حركت ",
          "appliedForce": "نيروي وارد شده",
          "leftForce": "نيروي سمت چپ",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "نيروي سمت راست",
          "sound": "صدا",
          "lots": "زياد",
          "forces": "نيروها",
          "motion": "حركت",
          "tugOfWar": "طناب كشي",
          "go": "برو",
          "newtons.n": "بر حسب نيوتون",
          "sumOfForcesEqualsZero": "جمع نيروها = 0",
          "blueWins": "آبي برنده شده",
          "speed": "سرعت",
          "sumOfForces": "جمع نيروها",
          "return": "بازگشت",
          "translation.credits": "<html>خليلي بروجني<br> وب سايت www.avang.org <br></html>",
          "newtons": "نيوتون",
          "masses": "جرم ها",
          "forceReadout.pattern": "{0}N"
        } );